module.exports = __webpack_public_path__ + "img/ring_skip_skip_0_null@3x.36dacfea.png";